import BatchEditPageDetails from './BatchEditPageDetails';

export default BatchEditPageDetails;
